import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=608bcb9e&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&id=608bcb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bcb9e",
  null
  
)

export default component.exports